import { useState } from 'react'
import { useDevToolsStore } from '../store/devtools-store'
import { JsonTree } from './json-tree'

export function StateTab() {
  const stateSnapshot = useDevToolsStore((s) => s.stateSnapshot)
  const runtime = useDevToolsStore((s) => s.runtime)
  const refreshState = useDevToolsStore((s) => s.refreshState)
  const [search, setSearch] = useState('')

  const hasState = Object.keys(stateSnapshot).length > 0

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-border">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search state..."
          className="flex-1 bg-muted/50 rounded px-2 py-1 text-xs outline-none focus:ring-1 focus:ring-ring"
        />
        {runtime && (
          <button
            onClick={refreshState}
            className="text-xs text-muted-foreground hover:text-foreground px-1"
            title="Refresh state"
          >
            Refresh
          </button>
        )}
      </div>
      <div className="flex-1 overflow-auto px-3 py-2">
        {!runtime && (
          <p className="text-xs text-muted-foreground">
            No runtime — switch to Preview mode to see live state.
          </p>
        )}
        {runtime && !hasState && (
          <p className="text-xs text-muted-foreground">State is empty.</p>
        )}
        {hasState && (
          <JsonTree data={stateSnapshot} defaultExpanded searchTerm={search} />
        )}
      </div>
    </div>
  )
}
